module.exports = __webpack_public_path__ + "img/sloth-hanging.70904d9.png";